(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yotpo-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.faqs-tab-btn');
  const tabContents = document.querySelectorAll('.faqs-tab-content');
  const defaultTab = 'points';

  // Show default tab on load
  // Only the selected tab is a tab stop; the arrow keys below move between them.
  tabButtons.forEach(button => {
    if (button.dataset.tab === defaultTab) {
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
      button.tabIndex = 0;
    } else {
      button.setAttribute('aria-selected', 'false');
      button.tabIndex = -1;
    }
  });

  tabContents.forEach(content => {
    if (content.id === `tab-content-${defaultTab}`) {
      content.removeAttribute('hidden');
    } else {
      content.setAttribute('hidden', '');
    }
  });

  // Tab switching + auto-scroll into view
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Deactivate all tabs
      tabButtons.forEach(btn => {
        btn.classList.remove('active');
        btn.setAttribute('aria-selected', 'false');
        btn.tabIndex = -1;
      });

      // Hide all tab contents
      tabContents.forEach(content => content.setAttribute('hidden', ''));

      // Activate clicked tab
      const targetContent = document.getElementById(`tab-content-${button.dataset.tab}`);
      button.classList.add('active');
      button.setAttribute('aria-selected', 'true');
      button.tabIndex = 0;
      if (targetContent) targetContent.removeAttribute('hidden');

      // Smooth scroll the clicked tab button into view
      button.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    });
  });

  // Arrows, Home and End move along the tabs and select as they go (the ARIA tabs pattern).
  const tabList = document.querySelector('.faqs-tabs');
  if (tabList) {
    tabList.addEventListener('keydown', (event) => {
      const tabs = Array.from(tabButtons);
      const at = tabs.indexOf(document.activeElement);
      const to = { ArrowRight: at + 1, ArrowLeft: at - 1, Home: 0, End: tabs.length - 1 }[event.key];
      if (at === -1 || to === undefined) return;
      event.preventDefault();
      const tab = tabs[(to + tabs.length) % tabs.length];
      tab.focus();
      tab.click();
    });
  }

  // Accordion logic. oa-a11y-controls.js makes the titles buttons; their state is kept here.
  document.querySelectorAll('.faqs-accordion-item').forEach(item => {
    const title = item.querySelector('.faqs-accordion-title');
    title.setAttribute('aria-expanded', 'false');
    const icon = title.querySelector('.faqs-icon');
    if (icon) icon.setAttribute('aria-hidden', 'true');
    title.addEventListener('click', () => {
      const parent = item.closest('.faqs-tab-content');
      parent.querySelectorAll('.faqs-accordion-item').forEach(other => {
        if (other !== item && other.classList.contains('active')) {
          other.classList.remove('active');
          other.querySelector('.faqs-accordion-title').setAttribute('aria-expanded', 'false');
          other.querySelector('.faqs-accordion-content').style.maxHeight = '0';
        }
      });

      item.classList.toggle('active');
      title.setAttribute('aria-expanded', item.classList.contains('active'));
      const content = item.querySelector('.faqs-accordion-content');
      content.style.maxHeight = item.classList.contains('active') ? content.scrollHeight + 'px' : '0';
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
